<template>
  <div>
    <div class="products-details-section__grid grid gap-4">
      <div class="[grid-area:header]">
        <ProductHeader :product="product" />
      </div>
      <div class="[grid-area:gallery]">
        <ProductGallery
          v-if="product"
          :product="product"
          :enable-zoom="true"
          :thumb-width="160"
          :thumb-height="100"
          :attributes-localized="attributesLocalized"
        />
      </div>
      <div class="[grid-area:pricing]">
        <ProductPricingSection
          :product="product"
          :attributes-localized="attributesLocalized"
          :product-adjusted-for-cart="productAdjustedForCart"
          :available-quantity="availableQuantity"
          :stock="stock"
          :loading-stocks="loadingStocks"
          :has-alternative-products="hasAlternativeProducts"
        />
      </div>
      <div class="[grid-area:details]">
        <ProductQuickDetails
          :product="product"
          :attributes-localized="attributesLocalized"
          :should-show-related-accessories="shouldShowRelatedAccessories"
        />
      </div>
      <div class="[grid-area:review]">
        <ProductTopReview :review="topReview" />
      </div>
    </div>
    <transition name="sf-collapse-bottom">
      <FloatingAddToCart
        v-if="showFloatingAddToCart"
        :product="product"
        :product-adjusted-for-cart="productAdjustedForCart"
      />
    </transition>
    <ProductDetailsMetaSchema
      :attributes-localized="attributesLocalized"
      :product="product"
    />
  </div>
</template>
<script lang="ts">
import type { ProductVariant } from '~~/types/commercetools';
import type { ProductProcessedAttributes } from '~~/types/product/attribute/ProductProcessedAttributes';
import type { ProductReview } from '~~/types/product/attribute/ProductReview';

export default defineComponent({
  name: 'ProductDetailsSection',
  props: {
    product: {
      type: Object as PropType<ProductVariant>,
      required: true,
    },
    attributesLocalized: {
      type: Object as PropType<ProductProcessedAttributes>,
      required: true,
    },
    productAdjustedForCart: {
      type: Object,
      required: true,
    },
    availableQuantity: {
      type: Number,
      required: true,
    },
    stock: {
      type: Number,
      required: true,
    },
    loadingStocks: {
      type: Boolean,
      required: true,
    },
    topReview: {
      type: Object as PropType<ProductReview>,
      default: () => {

        return {};
      
      },
    },
    shouldShowRelatedAccessories: {
      type: Boolean,
      required: true,
    },
    hasAlternativeProducts: {
      type: Boolean,
      default: false,
    },
  },
  setup() {

    const { showFloatingAddToCart } = useFloatingATCSection();

    return {
      showFloatingAddToCart,
    };
  
  },
});
</script>

<style lang="scss" scoped>
.products-details-section {
  &__grid {
    grid-template-areas:
      "header"
      "gallery"
      "pricing"
      "details"
      "review";
    grid-template-columns: 100%;
  }

  @include for-desktop {
    &__grid {
      grid-template-areas:
        "gallery header header"
        "gallery details pricing"
        "review details pricing";
      grid-template-columns: 2fr 1fr 1fr;
      grid-template-rows: auto auto 1fr;
    }
  }
}
</style>
